import axios from 'axios';

const unsubscribeFromBuyerShowings = async (dashboardId: string) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/delete_buyer_subscription`,
    method: 'post' as const,
  };

  await axios.request<{ id: string }>(config);
};

export default unsubscribeFromBuyerShowings;
